import { axiosInstance } from "./axiosInstance";

export const bannerService = {
    getBanner: async (filter) => {
        return await axiosInstance.get('/api/superadmin/banner', { params: filter })
    },
    createBanner: async (data) => {
        return await axiosInstance.post('/api/superadmin/banner/create', data)
    },
    updateBanner: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/banner/update/${id}`, data)
    },
    deleteBanner: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/banner/delete/${id}`)
    }
}